import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import BankForm from '../../../components/forms/BankForm';
import { useBankApi } from '../../../hooks/useBankApi';
import { useNavigate, useParams } from 'react-router-dom';
import { BankDTO } from '../../../services/apiClient';

const BankEdit: React.FC = () => {
  const { getById, edit } = useBankApi();
  const [entityData, setEntityData] = useState<BankDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Banks', href: '/admin/banks' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Bank data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/banks');
    } catch (error) {
      console.error('Error updating Bank:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      title="Edit Bank"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
        {entityData ? (
          <BankForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/banks')}
            //isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default BankEdit;